import auth from '@/router/auth'
import QuestionCreate from '@/components/questions-online/Create'
import QuestionUpdate from '@/components/questions-online/Update'
import QuestionShow from '@/components/questions-online/Show'

export default [
  {
    path: '/test-kits-online/:id/questions-online/create',
    name: 'questions-online-create',
    component: QuestionCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/test-kits-online/:id/questions-online/update/:question_id',
    name: 'questions-online-update',
    component: QuestionUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/test-kits-online/:id/questions-online/show/:question_id',
    name: 'questions-online-show',
    component: QuestionShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/questions-online/router.js